module.exports = __webpack_public_path__ + "img/addfriend.34510ade.png";